import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  bulkEditNextYearClassesPath,
  editNextYearClassPath,
  exchangeSchoolYearPath,
  newNextYearClassPath,
  Context,
  fetchNextClasses,
  fetchTeachers,
} from "../../../managerStore";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import ClassList from "../../../templates/manager/ClassList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const { nextYear } = useCurrentYear();

  React.useEffect(() => {
    dispatch(fetchNextClasses(nextYear));
  }, [dispatch, nextYear]);

  React.useEffect(() => {
    dispatch(fetchTeachers());
  }, [dispatch]);

  const toBuildNewClass = React.useCallback(
    () => history.push(newNextYearClassPath),
    [history],
  );

  const toBuildClass = React.useCallback(
    id => {
      history.push(`${editNextYearClassPath}/${id}`);
    },
    [history],
  );

  const toBulkEditClasses = React.useCallback(
    () => history.push(bulkEditNextYearClassesPath),
    [history],
  );

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
        ]}
        currentTitle={`${titles.nextYearClasses} (${nextYear}年度)`}
      />
      <ClassList
        title={`${titles.nextYearClasses} (${nextYear}年度)`}
        year={nextYear}
        teachers={state.teachers}
        isNextYear={true}
        toBuildNewClass={toBuildNewClass}
        toBuildClass={toBuildClass}
        toBulkEditClasses={toBulkEditClasses}
        classes={state.next_classes}
      />
    </div>
  );
};
